
import CalendlySection from "../components/Home/CalendlySection";

const BookDemo = () => {
  return (
    <main className="min-h-screen w-full bg-gray-900 pt-20">
      <CalendlySection />
    </main>
  );
};

export default BookDemo;
